import React, { useContext, useState, useRef } from "react";
import { Button } from "@windmill/react-ui";
import { useDispatch } from "react-redux";
import "./EditProfile.css";
import { updateUser } from "../../Redux/userReducer";
import Swal from "sweetalert2";
import EditProfileMap from "./EditProfileMap";
import Error from "../components/form/Error";
import { useSelector } from "react-redux/es/exports";
import useStaffSubmit from "../hooks/useStaffSubmit";
import LabelArea from "../components/form/LabelArea";
import InputArea from "../components/form/InputArea";
import { AdminContext } from "../context/AdminContext";
import SelectRole from "../components/form/SelectRole";
import GoogleMapReact from "google-map-react";
import language from "../../language";
// import { getUser } from "../../../Redux/userReducer";
import { getUser } from "../../Redux/userReducer";
import PageTitle from "../components/Typography/PageTitle";
import Uploader from "../components/image-uploader/Uploader";
import { useEffect } from "react";
import { updateOperator } from "../../Redux/userReducer";
import { getAllOperators } from "../../actions/operators";
import store from "../../store";
import { connect } from "react-redux";
import RoomIcon from "@mui/icons-material/Room";
import OperatorPictursSlider from "./OperatorPictursSlider";
import Select from "react-select";
import countryList from "react-select-country-list";
import { RxCross2 } from "react-icons/rx";



const AnyReactComponent = ({ text }) => (
  <div style={{ width: "30px", height: "30px" }}>
    <RoomIcon style={{ width: "100%", height: "100%", color: "#22C55E" }} />
  </div>
);
const EditProfile = ({ operators: { operators } }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [confirmPassword, setConfirmPassword] = useState('');
  const options = countryList().getData();
  const userDataStore = useSelector(
    (state) => state?.userReducer?.userData?.user
  );
  let currentoperator = operators?.filter(
    (operator) => operator.userId === userDataStore?._id
  );
  if (currentoperator) {
    currentoperator = currentoperator[0];
  }

  const confirmNew = (e) => {
    setConfirmPassword(e.target.value)
  }
  const [user, setUser] = useState({
    companyname: currentoperator?.companyname || "",
    username: currentoperator?.username || "",
    contactnumber: currentoperator?.contactnumber || "",
    email: currentoperator?.email || "",
    companyaddress: currentoperator?.companyaddress || "",
    companycontactnumber: currentoperator?.companycontactnumber || "",
    support_Email: currentoperator?.support_Email || "",
    about_company: currentoperator?.about_company || "",
    countries_array: currentoperator?.countries_array || [],
    website_link: currentoperator?.website_link || "",
    // sm_links: Array.isArray(currentoperator?.sm_links) && currentoperator.sm_links.length > 0
    //   ? currentoperator.sm_links
    //   : [{ title: "", link: "" }],
    sm_links: currentoperator?.sm_links?.length > 0 ? currentoperator.sm_links : [""],
    companylocation: currentoperator?.companylocation || { lat: null, lng: null },
    oldPassword: "",
    newPassword: "",
    luggageAllowance: currentoperator?.luggageAllowance || 1,
    cancellation_Policy: currentoperator?.cancellation_Policy || "",
    Terms_Conditions: currentoperator?.Terms_Conditions || "",
  });

  const [logoUrl, setLogoUrl] = useState();
  const [logoFile, setLogoFile] = useState(null);
  const defaultProps = {
    center: {
      lat: 23.424076, // Default latitude for UAE
      lng: 53.847818, // Default longitude for UAE
    },
    zoom: 7,
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setLogoUrl(imageUrl);
      setLogoFile(file);
    }
  };
  const handleUploadButtonClick = () => {
    fileInputRef.current.click();
  };

  const ResetState = () => {
    setLogoUrl(null)
  }




  const handleChange = (e, index, field) => {
    if (Array.isArray(e)) {
      // Handle multi-select for countries_array
      const selectedCountries = e.map((option) => option.label);
      setUser({
        ...user,
        countries_array: selectedCountries,
      });
    } else {
      const { name, value } = e.target;

      if (name === "sm_links") {
        // Handle social media links (array of strings)
        const updatedLinks = [...user.sm_links];
        updatedLinks[index] = value; // Directly update the string at the specified index
        setUser({
          ...user,
          sm_links: updatedLinks,
        });
      } else if (name === "companylocation") {
        // Handle nested object (e.g., companylocation)
        setUser({
          ...user,
          [name]: {
            ...user[name], // Preserve existing nested fields
            [field]: value, // Update the specific field (e.g., lat or lng)
          },
        });
      } else {
        // Handle regular inputs
        setUser({
          ...user,
          [name]: value,
        });
      }
    }
  };


  const addSocialMediaLink = () => {
    // Add an empty string to the sm_links array
    setUser({
      ...user,
      sm_links: [...user.sm_links, ""],
    });
  };

  const removeSocialMediaLink = (index) => {
    // Remove the link at the specified index
    const updatedLinks = user.sm_links.filter((_, i) => i !== index);
    setUser({
      ...user,
      sm_links: updatedLinks,
    });
  };



  console.log(user, "useroperat")
  const {
    state: { adminInfo },
  } = useContext(AdminContext);
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;

  const { register, handleSubmit, onSubmit, errors, imageUrl, setImageUrl } =
    useStaffSubmit(adminInfo?._id);

  const submitUpdate = async () => {
    const dataImage = new FormData();
    if (logoFile) {
      dataImage.append("image", logoFile);
    }

    const data = {
      companyname: user.companyname,
      username: user.username,
      contactnumber: user.contactnumber,
      email: user.email,
      companyaddress: user.companyaddress,
      companycontactnumber: user.companycontactnumber,
      about_company: user.about_company,
      support_Email: user?.support_Email,
      companylocation: user.companylocation,
      countries_array: user.countries_array,
      website_link: user.website_link,
      sm_links: user.sm_links,
      luggageAllowance: user.luggageAllowance,
      cancellation_Policy: user.cancellation_Policy,
      Terms_Conditions: user.Terms_Conditions,
      oldPassword: user.oldPassword,
      newPassword: user.newPassword,
    };
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        dataImage.append(key, data[key]);
      }
    }


    if (data.newPassword) {
      if (confirmPassword != data.newPassword) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please reenter your passwords. New Password & Confirm Password should be same to update password!",
        });
        return;
      }
    } else {
      if (!data.oldPassword) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter your current password to update user.",
        });
        return;
      }
      if (!data.email) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Email should not be empty",
        });
        return;
      }
    }



    const response = await dispatch(updateOperator(dataImage));

    if (response?.payload?.data?.success) {
      Swal.fire({
        icon: "success",
        title: "",
        text: "Operator Updated",
      });
    }
  };

  useEffect(() => {
    store.dispatch(getAllOperators());
    handleGetUserData();
  }, []);
  useEffect(() => {
    setUser({
      companyname: currentoperator ? currentoperator.companyname : "",
      username: currentoperator?.username ? currentoperator?.username : "",
      contactnumber: currentoperator?.contactnumber ? currentoperator?.contactnumber : "",
      email: userDataStore ? userDataStore?.email : "",
      password: "",
      companyaddress: currentoperator?.companyaddress ? currentoperator?.companyaddress : "",
      companycontactnumber: currentoperator?.companycontactnumber ? currentoperator?.companycontactnumber : "",
      support_Email: currentoperator?.support_Email ? currentoperator?.support_Email : "",
      about_company: currentoperator?.about_company ? currentoperator?.about_company : "",
      countries_array: currentoperator?.countries_array || [],
      website_link: currentoperator?.website_link || "",
      companylocation: currentoperator?.companylocation ? currentoperator?.companylocation : {
        lat: null,
        lng: null,
      },
      oldPassword: "",
      newPassword: "",
      // sm_links: Array.isArray(currentoperator?.sm_links) && currentoperator.sm_links.length > 0
      //   ? currentoperator.sm_links
      //   : [{ title: "", link: "" }],
      sm_links: currentoperator?.sm_links?.length > 0 ? currentoperator.sm_links : [""],
      luggageAllowance: currentoperator?.luggageAllowance ? currentoperator?.luggageAllowance : "",
      cancellation_Policy: currentoperator?.cancellation_Policy ? currentoperator?.cancellation_Policy : "",
      Terms_Conditions: currentoperator?.Terms_Conditions ? currentoperator?.Terms_Conditions : "",
    });
  }, [currentoperator]);



  const handleGetUserData = async () => {
    store.dispatch(getUser());
  };
  return (
    <>
      <PageTitle>
        {" "}
        {languageSelectedEnglish ? "Edit Profile" : language.editProfile}
      </PageTitle>
      <div className="container p-6 mx-auto bg-white rounded-lg">
        <form onSubmit={handleSubmit(submitUpdate)}>
          <div className="p-6 flex-grow scrollbar-hide w-full max-h-full">
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Company Logo"
                    : language.companyLogo
                }
              />
              <div className="col-span-8 sm:col-span-4">
                {!logoUrl && (<div className="upload-section">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    style={{ display: "none" }} // Hide default input
                  />
                  <button
                    className="SAVEButton-Profile h-8 px-3 updateBtn1"
                    onClick={handleUploadButtonClick}
                    type="button"  // Prevents form submission
                  >
                    Upload Image
                  </button>
                </div>
                )}

                {/* Display Uploaded Image */}
                {logoUrl && (
                  <>
                    <div style={{ width: "100%" }}>
                      <div className="uploaded-image-container" style={{ display: "flex", gap: "3px" }}>
                        <img src={logoUrl} alt="Uploaded" className="uploaded-logo-Profile" />
                        <RxCross2 style={{ color: "red", fontSize: "20px" }} onClick={ResetState} />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {/*    <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Username" />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label="Username"
                  name="username"
                  defaultValue={user.username}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder="Username"
                />
                <Error errorName={errors.name} />
              </div>
            </div> */}

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={languageSelectedEnglish ? "Email" : language.email}
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={languageSelectedEnglish ? "Email" : language.email}
                  /*    value={user.email} */
                  onChange={(e) => handleChange(e)}
                  name="email"
                  defaultValue={user.email}
                  type="text"
                  placeholder={
                    languageSelectedEnglish ? "Email" : language.email
                  }
                />
                <Error errorName={errors.email} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Contact Number"
                    : language.contactnumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish
                      ? "Contact Number"
                      : language.contactnumber
                  }
                  name="contactnumber"
                  defaultValue={user?.contactnumber}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Contact Number"
                      : language.contactnumber
                  }
                />
                <Error errorName={errors.phone} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Company Name"
                    : language.companyName
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish
                      ? "Company Name"
                      : language.companyName
                  }
                  name="companyname"
                  defaultValue={user.companyname}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Company Name"
                      : language.companyName
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Company Representative's Name"
                    : language.companyRepresentativeName
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish
                      ? "Company Representative's Name"
                      : language.companyRepresentativeName
                  }
                  name="username"
                  defaultValue={user.username}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Company Representative's Name"
                      : language.companyRepresentativeName
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Company Head Office Address"
                    : language.companyHeadOfficeAddress
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish
                      ? "Company Head Office Address"
                      : language.companyHeadOfficeAddress
                  }
                  name="companyaddress"
                  defaultValue={user.companyaddress}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Company Head Office Address"
                      : language.companyHeadOfficeAddress
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Company Head Office Phone Number"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish
                      ? "Company Head Office Phone Number"
                      : language.companyHeadOfficePhoneNumber
                  }
                  name="companycontactnumber"
                  defaultValue={user.companycontactnumber}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Company Head Office Phone Number"
                      : language.companyHeadOfficePhoneNumber
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>




            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Customer Support Email"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish
                      ? "Customer Support Email"
                      : language.companyHeadOfficePhoneNumber
                  }
                  name="support_Email"
                  defaultValue={user.support_Email}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Customer Support Email"
                      : language.companyHeadOfficePhoneNumber
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>



            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={languageSelectedEnglish ? "Operating Countries" : language.password}
              />
              <div className="col-span-8 sm:col-span-4">
                <Select
                  className="multiCoutrySelect"
                  isMulti
                  options={countryList().getData()}
                  value={countryList()
                    .getData()
                    .filter((option) => (user.countries_array || []).includes(option.label))}
                  onChange={(selectedOptions) => handleChange(selectedOptions)}
                />
              </div>
            </div>


            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={languageSelectedEnglish ? "About the Company" : language.password}
              />
              <div className="col-span-8 sm:col-span-4">
                <textarea className="DescriptionAre"
                  name="about_company"
                  defaultValue={user.about_company}
                  onChange={(e) => handleChange(e)}
                  placeholder="About the Company..."></textarea>
              </div>
            </div>


            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Website"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  name="website_link"
                  defaultValue={user.website_link}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder={
                    languageSelectedEnglish
                      ? "Website_Link"
                      : language.companyHeadOfficePhoneNumber
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>


            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Social Media Links"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                {user.sm_links.map((link, index) => (
                  <div key={index} style={{ marginBottom: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                    <input
                      type="text"
                      name="sm_links"
                      value={user.sm_links[index]}
                      onChange={(e) => handleChange(e, index)}
                      placeholder="Enter social media link"
                      className="sicialMediaInput"
                    />
                    <button type="button" onClick={() => removeSocialMediaLink(index)} style={{ color: "red" }}>
                      ✕
                    </button>
                  </div>
                ))}
                <button type="button" className="addmoreBtn" onClick={addSocialMediaLink}>
                  Add Social Media
                </button>
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Luggage Allowance"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  name="luggageAllowance"
                  defaultValue={user.luggageAllowance}
                  onChange={(e) => handleChange(e)}
                  type="number"
                  placeholder={
                    languageSelectedEnglish
                      ? "luggageAllowance"
                      : language.companyHeadOfficePhoneNumber
                  }
                />
                <Error errorName={errors.name} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Cancellation Policy"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <textarea className="DescriptionAre"
                  name="cancellation_Policy"
                  defaultValue={user.cancellation_Policy}
                  onChange={(e) => handleChange(e)}
                  placeholder="Cancellation Policy"></textarea>
              </div>
            </div>


            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Terms & Conditions"
                    : language.companyHeadOfficePhoneNumber
                }
              />
              <div className="col-span-8 sm:col-span-4">
                <textarea className="DescriptionAre"
                  name="Terms_Conditions"
                  defaultValue={user.Terms_Conditions}
                  onChange={(e) => handleChange(e)}
                  placeholder="Terms & Conditions"></textarea>
              </div>
            </div>


            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={languageSelectedEnglish ? "Current Password" : language.password}
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish ? "Current Password" : language.password
                  }
                  name="oldPassword"
                  type="password"
                  defaultValue={user.oldPassword}
                  onChange={(e) => handleChange(e)}
                  placeholder={
                    languageSelectedEnglish ? "Current Password" : language.password
                  }
                />
                <Error errorName={errors.role} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={languageSelectedEnglish ? "New Password" : language.password}
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish ? "New Password" : language.password
                  }
                  name="newPassword"
                  type="password"
                  defaultValue={user.newPassword}
                  onChange={(e) => handleChange(e)}
                  placeholder={
                    languageSelectedEnglish ? "New Password" : language.password
                  }
                />
                <Error errorName={errors.role} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={languageSelectedEnglish ? "Confirm new Password" : language.password}
              />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={
                    languageSelectedEnglish ? "Password" : language.password
                  }
                  type="password"
                  value={confirmPassword}
                  onChange={confirmNew}
                  placeholder={
                    languageSelectedEnglish ? "Confirm new Password" : language.password
                  }
                />
                <Error errorName={errors.role} />
              </div>
            </div>







            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea
                label={
                  languageSelectedEnglish
                    ? "Company Head Office Location"
                    : language.companyHeadOfficeLocation
                }
              />

              <EditProfileMap user={user} setUser={setUser} />
            </div>
          </div>
          {user?.companylocation.lat && (
            <div className="mapScreenshot">
              <div
                style={{
                  marginBottom: "15px",
                }}
              >
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${user.companylocation.lat},${user.companylocation.lng}`}
                  target="_blank"
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  https://www.google.com/maps/search/?api=1&query=
                  {user.companylocation.lat},{user.companylocation.lng}
                </a>
              </div>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyA_9dyGB-Du4nrXiyVLx_Ice7c93V-JOGY",
                }}
                defaultCenter={defaultProps.center}
                defaultZoom={15}
                center={user.companylocation}
                zoom={15}
              /* onClick={handleMapClick} */
              >
                {/*   {marker && (
                      <AnyReactComponent lat={marker.lat} lng={marker.lng} />
                    )} */}

                <AnyReactComponent
                  lat={user.companylocation.lat}
                  lng={user.companylocation.lng}
                />
              </GoogleMapReact>
            </div>
          )}
          <div className="flex flex-row-reverse pr-6 pb-6">
            <button
              className={`h-12 px-6 ${user.oldPassword ? 'updateBtn1' : 'disableBtn1'}`}
              onClick={submitUpdate}
              disabled={!user.oldPassword}
            // type="submit"
            >
              {languageSelectedEnglish
                ? "Update Profile"
                : language.updateProfile}
            </button>
          </div>
          <div>Note: Enter current password to update information (Enter new password to update password along with current password)</div>
        </form>

      </div>
      <div className="container p-6 mx-auto bg-white rounded-lg my-5" >
        <div className="container p-6 mx-auto bg-white rounded-lg" >
          <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 ">
            <LabelArea
              label={languageSelectedEnglish ? "Picturs" : language.password}
            />
            <div className="col-span-8 sm:col-span-4">
              <OperatorPictursSlider />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  operators: state.operators,
});

export default connect(mapStateToProps, null)(EditProfile);
